<template>
    <section class="map-infobox">
        <div class="info">
          <p class="info-caption">Порушник:</p>
          <p class="info-value violator">
            
            <template v-if="!d.properties.person">{{d.properties.legalEntityForm}}</template> 
            {{d.properties.entityName}} 
            
          </p>
          
          <template v-if="d.properties.entityId && d.properties.entityId !== 'Null'">
            <p class="info-caption">Детальніше:</p>
            <p class="info-value">
              <a 
                  :href="`https://opendatabot.ua/c/${d.properties.entityId}`" 
                  target="_blank"
                  title="Дивитись інформацію про підприємство у opendatabot"
              >
                  {{d.properties.entityId}}
              </a>
            </p>
          </template>
        </div>

        <div class="info">
          <p class="info-caption">Тип порушення:</p>
          <p class="info-value violator">{{d.properties.violationType}}</p>
        </div>

        <div class="info">
            <p class="info-caption">Статус порушення:</p>
            <p class="info-value">{{d.properties.completed ? "Виконано" : 'Не виконано'}}</p>
        </div>

        <div class="info">
            <p class="info-caption">Дата:</p>
            <p class="info-value violator">{{format_date(d.properties.date)}}</p>
        </div>

        <div class="info">
            <p class="info-caption">Адреса:</p>
            <p class="info-value address">{{d.properties.fullAddress || '[не вказано]'}}</p>
        </div>    

        <!--number,date,legalEntityForm,entityName,entityId,violationType,object,addressAdminUnitL1,addressAdminUnitL2,addressAdminUnitL3,addressPostName,addressThoroughfare,addressLocatorDesignator,Latitude,Longitude,status-->
    </section>    
</template>

<script>
import * as d3 from 'd3'
const time_format =  d3.timeFormat("%Y-%m-%d")

export default {
    name: "info-box",
    props: {
        d: Object
    },
    methods: {
      format_date(v) {
        return time_format(v);
      }
    }
}
</script>

<style lang="scss" scoped>

.map-infobox {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-column-gap: 2em;

  .info {
    border-top: 1px solid black;
  }

  .info-caption {
    font-size: 0.7em;
    margin-bottom: 0.015em;
  }

  .info-value {
    min-height: 1.7em;
    
    &.fail {
      color: var(--col-fail);
    }
    
    &.success {
      color: var(--col-win);
    }
  }

  
  a {
    border-bottom: 2px dotted;

    &:hover {
      background-color: #E7EEF3;
    }
    img {
      height: 1em;
      display: inline-block;
      vertical-align: baseline;
    }

  }

  .violation {
    margin: 1em 0;
    font-style: italic;
  }
}
</style>>